import React, { useState, useEffect } from 'react';
import { Modal, Spin, message } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import IncubatorRegister from '../auth/IncubatorRegister';
import incubatorApi from '../../api/incubatorApi';

const EditIncubatorProfile = ({ visible, onClose, onSuccess, incubatorData: initialData }) => {
  const [loading, setLoading] = useState(false);
  const [incubatorData, setIncubatorData] = useState(null);

  useEffect(() => {
    if (visible) {
      if (initialData) {
        // Use the data passed as prop
        setIncubatorData(initialData);
      } else {
        // Fetch data if not provided
        fetchIncubatorData();
      }
    }
  }, [visible, initialData]);

  const fetchIncubatorData = async () => {
    try {
      setLoading(true);
      const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
      
      if (userInfo.incubator) {
        const data = await incubatorApi.getIncubatorProfile(userInfo.incubator);
        setIncubatorData(data);
      }
    } catch (error) {
      message.error('Failed to load incubator data');
      console.error('Error fetching incubator data:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSuccess = () => {
    message.success('Incubator profile updated successfully');
    onSuccess();
    onClose();
  };

  return (
    <Modal
      title={
        <span style={{ 
          fontSize: '20px', 
          fontWeight: 500, 
          color: '#3C007A',
          fontFamily: "'Rubik', sans-serif"
        }}>
          Edit Incubator Profile
        </span>
      }
      open={visible}
      onCancel={onClose}
      footer={null}
      width="90%"
      style={{ maxWidth: '900px', top: 20 }}
      bodyStyle={{ 
        maxHeight: 'calc(90vh - 110px)', 
        overflowY: 'auto',
        padding: '24px'
      }}
      destroyOnClose
    >
      {loading ? (
        <div style={{ 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center', 
          minHeight: '200px' 
        }}>
          <Spin 
            indicator={<LoadingOutlined style={{ fontSize: 48, color: '#3C007A' }} spin />} 
          />
        </div>
      ) : (
        <IncubatorRegister
          onSuccess={handleSuccess}
          isAdminEdit={true}
          selfEdit={true}
          editingIncubator={incubatorData}
        />
      )}
    </Modal>
  );
};

export default EditIncubatorProfile;
